import React from 'react';
import pluralize from 'pluralize';

import DemoGuardedButton from '../shared/demoGuardedButton';
import { getSubscriptionTheme } from './constants';

const AvailableCredits = ({ userHasValidSub, redeemPremiumCredits, availableCredits, subscriptionType, }) => {
  const redeemIfNoCurrentSub = () => {
    if (userHasValidSub) {
      alert('You cannot redeem credits while you have a valid subscription. You must wait until your current subscription has expired to redeem them.');
    } else {
      redeemPremiumCredits();
    }
  };

  function handleEarnCreditsClick() { window.location.href = '/referrals' }

  // When the user's subscription has expired (or doesn't exist) fall back to
  // the neutral Basic theme so this card matches the rest of the page.
  const themeClass = userHasValidSub ? getSubscriptionTheme(subscriptionType) : 'basic-theme'
  let buttonClassName = 'quill-button contained gold small focus-on-light'
  if (themeClass === 'school-theme') {
    buttonClassName = 'quill-button contained maroon small focus-on-light'
  }

  let button;
  if (availableCredits > 0) {
    button = <button className={buttonClassName} onClick={redeemIfNoCurrentSub} type="button">Redeem Premium Credits</button>;
  } else {
    button = (
      // DemoGuardedButton needs to be inside of a div because the button shifts when the editing is disabled modal is open
      <div>
        <DemoGuardedButton className={buttonClassName} onClick={handleEarnCreditsClick}>Earn premium credits</DemoGuardedButton>
      </div>
    )
  }
  const weeksOfCredit = Math.round(availableCredits / 7)
  const whiteIfNoCredit = weeksOfCredit === 0 ? 'no-credits' : null;
  return (
    <section aria-label="Available Credits" className={`${whiteIfNoCredit || ''} ${themeClass} available-credit flex-row vertically-centered space-between`}>
      <div className="credit-quantity">
        You have <span>{`${weeksOfCredit} ${pluralize('week', weeksOfCredit)} `}</span> of Teacher Premium Credit available.
      </div>
      {button}
    </section>
  );
}

export default AvailableCredits
